import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index'

const app = createApp(App)
const pinia = createPinia()
app.use(pinia)

// Initialize auth store BEFORE adding router
import { useAuthStore } from '@/stores/auth'
const authStore = useAuthStore(pinia)
await authStore.initialize()

app.use(router)
app.mount('#app')
